import React from "react";
import { TbEdit } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

const GroupItem = ({ group, pageLanguage }) => {
  const navigate = useNavigate();
  const rowClass = pageLanguage === "fa" ? "groupPage-table-fa" : "groupPage-table-en";

  return (
    <tr
      className={rowClass}
      onClick={() => navigate(`/admin/panel2/${pageLanguage}/group-page/${group?.ProductGroupId}`)}
    >
      <td>{pageLanguage === "fa" ? group?.ProductGroupName : group?.ProductGroupENName}</td>
      <td>{group?.ProductGroupId}</td>
      <td>
        <button
          onClick={() =>
            navigate(`/admin/panel2/${pageLanguage}/group-page/${group?.ProductGroupId}`)
          }
        >
          <TbEdit />
        </button>
      </td>
    </tr>
  );
};

export default GroupItem;
